

import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from "react-redux"
import { useSearchParams } from "react-router-dom"
import { Loading } from '../../../../../Helper/Loading'
import Header from '../../../../../Components/Header/Header'
import Sidebar from '../../../../../Components/Sidebar/Sidebar'
import { useAuthState } from '../../../../../Helper/Context'
import PillerWiseBenchMarkModal from './Modal/PillerWiseBenchMarkModal'
import { Get_T_ELE_Excel_CurrentRating_Tempdata_SelectTableDataAPI } from '../../../../../Redux/ElectricalSlice/PillerWiseBenchMarkSlice'
import { PillerWiseDownloadBenchMark } from './PillerWiseDownloadBenchMark'
import { PillerWiseUploadBenchMark } from './PillerWiseUploadBenchMark'

export const PillerWiseBenchMark = () => {

    const userDetails = useAuthState();
    const { UserID, token, RoleID } = userDetails.user
    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let searchName = searchParams.get("name")
    let ApiFlag = searchParams.get("ApiFlag")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")
    let DashProjectTypeId = searchParams.get("DashProjectTypeId")


    // ----------pagination-------------
    const [PerPageCount, setPerPageCount] = useState(10)
    const [TotalCount, setTotalCount] = useState(0)
    const [To, setTo] = useState(10)
    const [From, setFrom] = useState(1)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)

    const [isSearch, setIsSearch] = useState(false)
    const [IsClear, setIsClear] = useState(false)
    const [IsPost, setIsPost] = useState(false)
    const [YearValue, setYearValue] = useState(0)
    const [ImagePopUpData, setImagePopUpData] = React.useState('')
    const [showImagePopup, setshowImagePopup] = React.useState(false)
    const [showUploadData, setUploadData] = useState(1);
    const [OpenCount, setOpenCount] = useState(false)
    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')

    const [WardName, setWardName] = useState({
        DDL: [],
        ID: '0',
        Label: "Select...",
    })

    const [VendorName, setVendorName] = useState({
        DDL: [],
        ID: '0',
        Label: "Select...",
    })

    const [FinancialYear, setFinancialYear] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })
    const [Month, setMonth] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",

    })

    const [DesignationPopupShow, setDesignationPopupShow] = useState()

    const handleAddOnClick = () => {
        setapiFlag('Insert')
        setDesignationPopupShow(true)
    }
    const handleEditOnClick = (item) => {
        setrowData(item)
        setDesignationPopupShow(true)
        setapiFlag('Update')
    }

    const handleOnCloseClick = () => {
        setDesignationPopupShow(false)
        handleIsPost()
    }

    const handleClear = () => {
        setTo(10)
        setFrom(1)
        setCurrentPage(0)
        setIsClear(!IsClear)
        setWardName({
            ...WardName,
            ID: 0,
            Label: 'Select...',
        })

    }

    const handleIsPost = () => {
        setIsPost(!IsPost)
    }

    const handleShowImage = (img) => {
        setshowImagePopup(true)
        setImagePopUpData(img)
    }

    useEffect(() => {
        handleGetData()
    }, [FinancialYear?.ID, Month?.ID, WardName?.ID, To, VendorName?.ID])

    useEffect(() => {
        setCurrentPage(0)
        setFrom(1)
        setTo(10)
    }, [FinancialYear?.ID, Month?.ID, WardName?.ID])

    const handleGetData = () => {
        const data = {
            T_ELE_Excel_CurrentRating_TempdataID: '0',
            M_FinancialYearID: FinancialYear?.ID,
            M_MonthID: Month?.ID,
            M_ELEC_WorkID: ProjectTypeId,
            M_Ward_Wise_VendorID: VendorName?.ID,
            M_WardID: WardName?.ID,
            M_ELEC_PillerID: '0',
            UserID: UserID,
            token: token,
            From: From,
            To: To
        }
        dispatch(Get_T_ELE_Excel_CurrentRating_Tempdata_SelectTableDataAPI({ data }))
    }
    const { tableData, isLoading } = useSelector(state => state.Get_T_ELE_Excel_CurrentRating_Tempdata_SelectTableData)


    return (
        <>
            {isLoading && <Loading />}
            <div>
                <Header
                    // DashboardHeading="Garden Maintainance"
                    DashboardName={DashboardName}
                />
                <div className="wrapper">
                    <Sidebar
                        ProjectTypeId={ProjectTypeId}
                        DashProjectTypeId={DashProjectTypeId}
                        active="pole" listActive="active" />

                    <div id="" className="content1">
                        <div className="data_mob1">
                            <div className="row m-1 py-1 pb-4 master_border">
                                <div className='row col-12'>
                                    <div className='col-4'>
                                        <h5 className="ps-1 py-1">Piller Wise Bench Mark</h5>
                                    </div>
                                    {
                                        RoleID == '1' &&
                                        <div className="btn-group col-4 my-1" role="group" aria-label="Basic outlined example" >

                                            <button
                                                onClick={() => setUploadData(1)}
                                                className={showUploadData == 1 ? "btn fw-bold px-4 activebutton text-white" : "text-black btn fw-bold px-4"}
                                                style={{ border: '1px solid #154779' }}
                                                type="button">
                                                Download
                                            </button>
                                            {
                                                RoleID == '1' &&
                                                <button
                                                    onClick={() => setUploadData(2)}
                                                    className={showUploadData == 2 ? "btn fw-bold px-4 activebutton text-white" : "text-black btn fw-bold px-4"}
                                                    style={{ border: '1px solid #154779' }}
                                                    type="button">
                                                    Upload
                                                </button>
                                            }


                                        </div>
                                    }
                                </div>
                                {
                                    showUploadData == 1 ?
                                        <PillerWiseDownloadBenchMark
                                            setUploadData={setUploadData}
                                            FinancialYear={FinancialYear}
                                            setFinancialYear={setFinancialYear}
                                            Month={Month}
                                            setMonth={setMonth}
                                            WardName={WardName}
                                            setWardName={setWardName}
                                            VendorName={VendorName}
                                            setVendorName={setVendorName}
                                        />
                                        :
                                        <PillerWiseUploadBenchMark
                                            setUploadData={setUploadData}
                                            FinancialYear={FinancialYear}
                                            setFinancialYear={setFinancialYear}
                                            Month={Month}
                                            setMonth={setMonth}
                                            WardName={WardName}
                                            setWardName={setWardName}
                                            VendorName={VendorName}
                                        />
                                }



                            </div>
                        </div>
                    </div>
                </div>

                {
                    DesignationPopupShow ?
                        <PillerWiseBenchMarkModal
                            open={DesignationPopupShow}
                            // popupHeading="Location Name"                         
                            handleIsPost={handleIsPost}
                            handleOnCloseClick={handleOnCloseClick}
                            Flag={apiFlag}
                            rowData={rowData}
                        />
                        : <></>
                }

            </div>

        </>
    )
}